// extracted by mini-css-extract-plugin
module.exports = {"parentContainer":"fixturePlayerControls_parentContainer__k2pr_","childContainer":"fixturePlayerControls_childContainer__37Uho","button":"fixturePlayerControls_button__3A-8M"};